import React from 'react';
import axios from 'axios';
import { Star, ExternalLink } from 'lucide-react';
import { testimonialsData, doctifyData } from '../data/mock';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Testimonials = () => {
  const [googleData, setGoogleData] = React.useState(null);

  React.useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/google-rating`).then((res) => {
      if (!cancelled && res.data?.rating != null) {
        setGoogleData(res.data);
      }
    }).catch(() => { /* hand-picked testimonials still render */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-bg"></div>

      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title text-white">Real Stories from Real Patients</h2>
          <p className="section-subtitle text-white">
            See how we&apos;ve helped patients find lasting relief from TMD, headaches, and chronic pain
          </p>

          {googleData ? (
            <a
              href={googleData.google_maps_uri || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="google-rating-pill"
              data-testid="google-rating-pill"
            >
              <span className="google-rating-pill-value">
                {Number(googleData.rating).toFixed(1)}
              </span>
              <span className="google-rating-pill-stars" aria-hidden="true">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star key={`pill-star-${i}`} size={14} fill="currentColor" />
                ))}
              </span>
              <span className="google-rating-pill-count">
                from <strong>{googleData.user_rating_count}</strong> Google reviews
              </span>
            </a>
          ) : null}
        </div>

        <div className="testimonials-grid">
          {testimonialsData.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-avatar">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="testimonial-info">
                  <h4 className="testimonial-name">{testimonial.name}</h4>
                  <p className="testimonial-condition">{testimonial.condition}</p>
                </div>
              </div>

              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={`${testimonial.id}-star-${i}`} className="star-icon" size={16} fill="currentColor" />
                ))}
              </div>

              <p className="testimonial-text">{testimonial.text}</p>

              <div className="testimonial-date">{testimonial.date}</div>
            </div>
          ))}
        </div>

        {googleData ? (
          <div className="testimonials-cta-row">
            <a
              href={googleData.google_maps_uri || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="see-all-reviews-btn"
              data-testid="see-all-reviews-btn"
            >
              See all {googleData.user_rating_count} reviews on Google
              <ExternalLink size={16} />
            </a>
            <a
              href={doctifyData.url}
              target="_blank"
              rel="noopener noreferrer"
              className="see-all-reviews-btn doctify-reviews-btn"
              data-testid="doctify-reviews-btn"
            >
              <span className="doctify-btn-score">
                {doctifyData.rating.toFixed(1)} <Star size={14} fill="currentColor" />
              </span>
              on Doctify
              <ExternalLink size={16} />
            </a>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default Testimonials;
